// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__1w-DT","row":"styles_row__3u7cK"};